import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../utils/cn';

const badgeVariants = cva(
  [
    'inline-flex items-center gap-1 font-medium text-xs',
    'px-2 py-1 rounded-md border',
    'transition-colors duration-200',
  ],
  {
    variants: {
      variant: {
        default: [
          'bg-gray-100 text-gray-800 border-gray-200',
        ],
        secondary: [
          'bg-gray-100 text-gray-700 border-gray-200',
        ],
        success: [
          'bg-green-100 text-green-800 border-green-200',
        ],
        destructive: [
          'bg-red-100 text-red-800 border-red-200',
        ],
        outline: [
          'text-gray-600 border-gray-300 bg-transparent',
        ],
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
